<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="70%" @opened="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="标题" prop="name">
        <el-input v-model="formData.name" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="key">
        <el-input v-model="formData.key" style="width:30%"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="value" style="width: 98%;">
        <el-input v-model="formData.value" type="textarea" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'config_bible_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加圣经配置',
      formData: {
        name: '',
        key: '',
        value: ''
      },
      formRules: {
        name: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        key: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑圣经配置'
        this.getConfigBibleInfo(this.id)
      }
    },
    async getConfigBibleInfo (id) {
      const res = await this.$http.get('/admin/config_bible/info/' + id)
      if (res.code === 0) {
        this.formData = {
          name: res.data.name,
          key: res.data.key,
          value: res.data.value
        }
      }
    }
  }
}
</script>

<style>
</style>
